export default __webpack_public_path__ + "static/media/task-crm.665eae7c.svg";